/** Presentation colors for the printed map PDF, shared between the layout and the legend. */
export const BOX_COLOR = '#cccccc';
export const SEPARATOR_COLOR = '#1a1e2c';
export const LABEL_COLOR = '#0c8599';
export const DATE_LABEL_COLOR = '#f08c00';
export const VALUE_COLOR = '#1a1e2c';
export const HEADING_COLOR = '#666666';
export const FOOTER_COLOR = '#888888';
